<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm02_halftitle"></a><a id="page_v"></a>W<span class="small">OODCUTS OF</span> W<span class="small">OMEN</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_halftitle.vue?447da67d